import { AfterContentInit, Component, OnInit, ViewChild } from '@angular/core';
import { SpraViewDataComponent } from '../spra-view-data/spra-view-data.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentAgingParam } from "../../../Models/searchCustomer";
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { MasterService } from '../../../Services/master.service';
import { TransactionService } from '../../../Services/transaction.service';
import { SPRASerivceRequestData, SPRAConsigneeDetail, DealerParam } from '../../../Models/ops';
import { NotificationService } from 'src/app/Services/notification.service';



@Component({
  selector: 'app-spra-service',
  templateUrl: './spra-service.component.html',
  styleUrls: ['./spra-service.component.css']
})
export class SpraServiceComponent implements OnInit, AfterContentInit {
  @ViewChild(SpraViewDataComponent) SpraViewDataComponent!: SpraViewDataComponent;
  SPRAId: number = 0;
  RefId: number = 0;
  //Msg :string="";
  //ApvStatus:string='A';
  paymentAgingParam: PaymentAgingParam;
  utility: Utility;
  spraReqServiceDetail: SPRASerivceRequestData;
  param: any;
  // ISService:boolean;
  ISService: boolean;
  IsCeha: boolean;
  _ConsigneeDetail: Array<SPRAConsigneeDetail> = new Array<SPRAConsigneeDetail>();

  public DistanceList: any[] = [];
  public DisableSubmit: boolean = false;

  public ConsigneeDetail?: Array<SPRAConsigneeDetail>;
  constructor(private router: Router,
    private _CookieService: CookieService,
    private _MasterService: MasterService,
    private _TransactionService: TransactionService,
    private _NotificationService: NotificationService
    , private route: ActivatedRoute
  ) {
    this.utility = new Utility(this._CookieService);

    this.spraReqServiceDetail = new SPRASerivceRequestData();
    this.paymentAgingParam = new PaymentAgingParam();
    this.param = this.router.getCurrentNavigation()?.extras.state;
    // this.ISService=true;
    this.ISService = true;
    this.IsCeha = false;

  }

  ngOnInit(): void {
    // this.route.params.subscribe((params) =>{
    //   if(params.SPRAId!=undefined && params.SPRAId!=0){
    //     this.param = params;
    //   }
    // });

    this._MasterService.GetDistance().subscribe((d) => {
      this.DistanceList.push({ "id": "0", "priceListTyp": "--Select--" });
      this.DistanceList = this.DistanceList.concat(d);
    }, (error) => {                              //Error callback
      this.utility.Error(error);
    });



    // this.spraReqServiceDetail.Distance="0";
    // this.spraReqServiceDetail.Location="0";
    // this.spraReqServiceDetail.ServiceBy="Sharp";
  }

  ngAfterContentInit() {

    // this.SPRAId = 2;
    // this.RefId = 142817;
    // this.paymentAgingParam.saleCode  = 'SM91216     ';
    // this.paymentAgingParam.officeId = 18;
    // this.paymentAgingParam.CompanyId =80064372;
    // this.ISService=true;

    if (this.param) {
      this.SPRAId = parseInt(this.param.SPRAId);
      this.RefId = parseInt(this.param.RefId);
      this.paymentAgingParam.saleCode = this.param.saleCode;
      this.paymentAgingParam.officeId = parseInt(this.param.officeId);
      this.paymentAgingParam.CompanyId = parseInt(this.param.CompanyID);
      // alert("hello");
      //  this.ISService=true;
      this.IsCeha = this.param.IsCeha;
      this.ISService = true;
    }


    setTimeout(() => {
      if (this.SPRAId != undefined && this.SPRAId > 0) {

        this.GetSpraConsigneeDetail();
      }
    }, 500);


  }

  // checkState(cons:SPRAConsigneeDetail,element:any,ASPelement:any){

  //   if(cons.Distance =="11")
  //   {
  //     if(ASPelement.checked == true)
  //     {
  //       // this._NotificationService.showError("Service By Should Be Sharp in case of direct service center.");
  //       element.checked=true;
  //       ASPelement.checked=false;
  //        return false;
  //     }      
  //   }
  //   else{
  //     if(element.checked == true)
  //     {
  //       // this._NotificationService.showError("Service By Should Be ASP in case of distance from service center is not direct.");
  //       element.checked=false;
  //       ASPelement.checked=true;
  //        return false;
  //     }  
  //   }
  //   if(element.checked == true)
  //   {
  //     cons.ServiceBy="Sharp";
  //   }
  //   else
  //   {
  //     cons.ServiceBy="ASP";
  //   }
  //    return false;
  // }

  changeDistance(cons: SPRAConsigneeDetail) {
    // this.cons.Distance=DistanceID;
    if (cons.Distance == "11") {
      cons.ServiceBy = "Sharp";
      // element.checked=true;
      // ASPelement.checked=false;
    }
    else {
      cons.ServiceBy = "ASP";
      // element.checked=false;
      // ASPelement.checked=true;
    }
  }

  Validation(): Boolean {
    let IsConsigneeValid: Boolean = true;
    this._ConsigneeDetail = [];
    if (!this.utility.CheckStringRequired(this.spraReqServiceDetail.Mssg)) {
      this._NotificationService.showError("Please Enter Remarks", "Service Detail.");
      IsConsigneeValid = false;
    }
    else if (this.ConsigneeDetail != undefined) {

      this.ConsigneeDetail.forEach(element => {
        if ((element.Location == "0" || element.Location == "") && IsConsigneeValid == true && this.spraReqServiceDetail.ApvStatus == 'A') {
          this._NotificationService.showError("Please Select Location", "Service Detail.");
          IsConsigneeValid = false;
        }
        else if (element.Distance == "0" && IsConsigneeValid == true && this.spraReqServiceDetail.ApvStatus == 'A') {
          this._NotificationService.showError("Please Select Distance", "Service Detail.");
          IsConsigneeValid = false;
        }
        else {
          let spraConsign: SPRAConsigneeDetail = new SPRAConsigneeDetail();
          spraConsign.Location = element.Location;
          spraConsign.Distance = element.Distance;
          spraConsign.ConsigneeId = element.ConsigneeId;
          spraConsign.ServiceBy = element.ServiceBy;
          spraConsign.ASPId = element.ASPId;
          this._ConsigneeDetail.push(spraConsign);
        }

      });

    }
    return IsConsigneeValid;
  }

  SpraSubmit() {

    try {
      this.DisableSubmit = true;
      if (this.Validation()) {
        let RedirectionPage: string = "spra-request-list"; //Added by rahul yadav on 7/6/2021
        if (this.IsCeha) {
          RedirectionPage = "spra-request-list/1";
        }

        this.spraReqServiceDetail.ConsigneeJSON = JSON.stringify(this._ConsigneeDetail);
        this.spraReqServiceDetail.SPRAId = this.SPRAId;
        this.spraReqServiceDetail.ValidateBy = this.utility.user.employeeId;

        this._TransactionService.UpdateSPRAServiceData(this.spraReqServiceDetail).subscribe((d): any => {
          if (d) {
            let Message: string = "SPRA request validated successfully."
            if (d == 0) {
              Message = "";
              Message = "Error Occured During Updation."
            }
            this.router.navigate([RedirectionPage], {
              state: {
                "Message": Message
              }
            });
          }
        }, (error) => {                              //Error callback
          this.utility.Error(error);
          throw new Error('SPRA request not validated.');
        });

      }else{
        this.DisableSubmit = false;  
      }
    } catch (Error: any) {
      this.DisableSubmit = false;
      console.log(Error.message);
    } finally {
      return true;
    }

  }

  GetSpraConsigneeDetail() {
    this._TransactionService.GetSPRAConsigneeDetail(this.SPRAId).subscribe((d: any) => {
      this.ConsigneeDetail = JSON.parse(d);
      if (this.ConsigneeDetail != undefined) {
        this.ConsigneeDetail.forEach(element => {
          element.Distance = "0";
          element.Location = "0";
          element.ServiceBy = "Sharp";
          element.ASPId = "0";

          let dlrPrm: DealerParam;
          dlrPrm = new DealerParam();
          dlrPrm.OfficeId = element.OfficeID;
          let DealerLst: any[] = [];

          // changed by Rajan Singh on 12 july 2021 - as service dealers are different
          // this._MasterService.GetDealer(dlrPrm).subscribe((dList) => {
          this._MasterService.getASCForOffice(dlrPrm).subscribe((dList) => {
            DealerLst.push({ "partnerId": "0", "partnerName": "--Select--" });
            DealerLst = DealerLst.concat(dList);

          }, (error) => {                              //Error callback
            this.utility.Error(error);
          });
          setTimeout(() => {
            element.DealerList = DealerLst;
          }, 500)
        });
      }

      this.spraReqServiceDetail.spraConsignee = JSON.parse(d);


    }, (error) => {                              //Error callback
      this.utility.Error(error);
    });

  }

}
